import React from 'react';
import CandidateEvaluationReportContent from './CandidateEvaluationReportContent';
import ProfileFitReportContent from './ProfileFitReportContent';
import TalentReportContent from './TalentReportContent';
import ProfileAssessmentReportContent from './ProfileAssessmentReportContent';

/**
 * TabbedReportsSection Component
 * Displays report content based on the reportType prop
 */
const TabbedReportsSection = ({ candidate, talent, evals, reportType = 'evaluation', hideCheatingProbability = false }) => {
  // Check if candidate data exists
  const hasCandidate = !!candidate;
  const hasEvaluationData = !!(candidate?.job_evals_report_json);
  const hasProfileData = !!(candidate?.job_profile_fit_report_json);

  // Check if talent data exists
  const hasTalent = !!talent;
  const hasTalentEvaluationData = !!(talent?.talent_report_json && reportType === 'evaluation');
  const hasTalentAssessmentData = !!(talent?.talent_report_json && reportType === 'assessment');

  return (
    <div className="mb-6">
      {/* Render Talent Report based on reportType */}
      {hasTalent && (
        <>
          {reportType === 'evaluation' && hasTalentEvaluationData && (
            <TalentReportContent talent={talent} />
          )}
          {reportType === 'assessment' && hasTalentAssessmentData && (
            <ProfileAssessmentReportContent talent={talent} />
          )}
        </>
      )}
      
      {/* Render Candidate Report based on reportType */}
      {hasCandidate && (
        <>
          {reportType === 'evaluation' && hasEvaluationData && (
            <CandidateEvaluationReportContent candidate={candidate} />
          )}
          {reportType === 'profile' && hasProfileData && (
            <ProfileFitReportContent candidate={candidate} />
          )}
        </>
      )}
    </div>
  );
};

export default TabbedReportsSection;
